// Spectator route stub (Phase 17.5.1).
//
// Reachable at `#/spectate/:gameId/:roomId`. Just renders a "coming soon"
// card so the route slot is claimed and other code can deep-link to it
// even before the real spectator UI lands. The full spectator path lives
// in `Vault/Architecture/multiplayer-foundation/Spectator Mode.md`.

export function renderSpectatorStub(
  host: HTMLElement,
  params: { gameId: string | null; roomId: string | null },
): void {
  host.innerHTML = '';
  const root = document.createElement('section');
  root.className = 'spectate-stub';
  root.style.cssText =
    'max-width:560px;margin:48px auto;padding:32px;text-align:center;background:var(--color-surface-subtle,#f3f3f3);border-radius:16px;';

  const title = document.createElement('h1');
  title.textContent = 'Spectator mode';
  title.style.cssText = 'margin:0 0 12px;font-size:24px;';
  root.appendChild(title);

  const sub = document.createElement('p');
  sub.style.cssText = 'margin:0 0 16px;color:var(--color-fg-muted,#888);';
  sub.textContent =
    'Coming soon - spectator mode is queued for Phase 17.5 follow-up.';
  root.appendChild(sub);

  if (params.gameId && params.roomId) {
    const ref = document.createElement('p');
    ref.style.cssText =
      'font-family:ui-monospace,monospace;font-size:13px;margin:0 0 24px;color:var(--color-fg-muted,#888);';
    ref.textContent = `Requested: ${params.gameId} / ${params.roomId}`;
    root.appendChild(ref);
  }

  const homeBtn = document.createElement('a');
  homeBtn.href = '#/';
  homeBtn.textContent = 'Back to games';
  homeBtn.style.cssText =
    'display:inline-block;padding:10px 18px;border-radius:8px;border:1px solid var(--color-border,#ccc);text-decoration:none;color:inherit;';
  root.appendChild(homeBtn);

  host.appendChild(root);
}

/**
 * Parse the hash and return `{gameId, roomId}` if the route is a spectator
 * path, else null. Accepts both:
 *   #/spectate/<gameId>/<roomId>
 *   #/spectate/<roomId>           (legacy short form - gameId reported as null)
 */
export function parseSpectatePath(
  path: string,
): { gameId: string | null; roomId: string } | null {
  const trimmed = path.startsWith('/') ? path.slice(1) : path;
  if (!trimmed.startsWith('spectate')) return null;
  const segments = trimmed.split('/').filter(Boolean);
  if (segments.length === 2 && segments[1]) {
    return { gameId: null, roomId: segments[1] };
  }
  if (segments.length === 3 && segments[1] && segments[2]) {
    return { gameId: segments[1], roomId: segments[2] };
  }
  return null;
}
